module.exports = __webpack_public_path__ + "img/deliver-img-4-4.2765f06d.png";